module.exports = __webpack_public_path__ + "img/driverR.290f83e4.png";